import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from '../styles'

/**
 *
 * @param {number} size size icon
 * @param {string} color color hexadecimal
 * @returns {React.Component}
 */
const IcDragHandle = ({ size, color }) => {
  return (
    <Icon
      className="IcDelete material-icons tw-items-center tw-justify-center"
      size={size}
      color={color}
    >
      drag_handle
    </Icon>
  )
}

IcDragHandle.propTypes = {
  size: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired
}

export default IcDragHandle
